<!--
    file type .....: HTML file: regions.component.html
    Created By ....: ianday
    Date ..........: 11/1/23 
-->
<div class="regions-container regions-container-disabled" id="regionDivId" >
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" >
    <mat-tree-node *matTreeNodeDef="let node" [disabled]="_disabledFlag" matTreeNodeToggle matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <mat-checkbox class="checklist-leaf-node" [disabled]="_disabledFlag"
              [checked]="checklistSelection.isSelected(node)"
              (change)="checklistSelection.toggle(node);">{{node.item}}</mat-checkbox>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" [disabled]="_disabledFlag" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.filename">
            <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
       <mat-checkbox [checked]="descendantsAllSelected(node)" [disabled]="_disabledFlag"
                     [indeterminate]="descendantsPartiallySelected(node)"
                     (change)="regionItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
    </mat-tree-node>
</mat-tree>
</div>
